import axios from 'axios';

const baseUrl =
  process.env.VUE_APP_SVC_URL_API || 'http://api.local.dpty.io/url/v1';

const http = axios.create({
  timeout: 5000,
  baseURL: baseUrl,
  crossdomain: true,
  // transformRequest: [function(data, headers) {
  //   console.log('transformRequest', headers);
  //   // http.defaults.headers.common['Authorization'] = `Bearer ${_localStorage.getItem('DEPUTY_HR:jwt')}`;
  //   headers.common['Authorization'] = `Bearer ${_localStorage.getItem('DEPUTY_HR:jwt')}`;
  //   console.log('transformRequest', headers);
  // //   // Do whatever you want to transform the data
  // //   console.log('transformRequest', headers);

  // //   // _localStorage.getItem('DEPUTY_HR:onboardingId'),
  //   return data;
  // }],
});

export default http;
export { http, baseUrl };
